import { render, staticRenderFns } from "./Colcade.vue?vue&type=template&id=44b7ad5c&scoped=true"
import script from "./Colcade.vue?vue&type=script&lang=js"
export * from "./Colcade.vue?vue&type=script&lang=js"
import style0 from "./Colcade.vue?vue&type=style&index=0&id=44b7ad5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b7ad5c",
  null
  
)

export default component.exports